import rankingScoreIndex from "../views/ranking-score/ranking-score-index";
import jobIndex from "../views/job/task-index.vue";

export default [
  {
    path: "/app/:userDeptRoleId/job/received",
    component: jobIndex,
    name: "job-index"
  },
  {
    path: "/app/:userDeptRoleId/job/received/detail/:id",
    name: "detail-job",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    }
  },

  {
    path: "/app/:userDeptRoleId/job/assigned",
    component: jobIndex,
    name: "job-index-assigned"
  },

  {
    path: "/app/:userDeptRoleId/job/assigned/detail/:id",
    name: "detail-job-assigned",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    }
  },

  {
    path: "/app/:userDeptRoleId/job/dept_assigned",
    component: jobIndex,
    name: "job-index-dept-assigned"
  },
  {
    path: "/app/:userDeptRoleId/job/dept_assigned/detail/:id",
    name: "detail-job-dept-assigned",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    }
  },

  {
    path: "/app/:userDeptRoleId/job/coordinate",
    component: jobIndex,
    name: "job-index-coordinate"
  },
  {
    path: "/app/:userDeptRoleId/job/coordinate/detail/:id",
    name: "detail-job-coordinate",
    components: {
      default: jobIndex,
      detail: () => import("../views/job/detail-job.vue")
    }
  },

  {
    path: "/app/:userDeptRoleId/rankingScoreIndex",
    component: rankingScoreIndex,
    name: "rankingScoreIndex"
  }
];



// WEBPACK FOOTER //
// ./src/router/job.js